/*
 * Copyright (c) 2021.
 * This file is part of the Compo B2B application.
 * (c) Compo soft - Ganturin Vladimir <gun2rin@gmail.com>
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */

import {ChangeDetectionStrategy, Component, OnInit} from '@angular/core';
import {NbWindowRef} from '@nebular/theme';
import {ApiResponse, BaseComponent, CustomerGroup, StoreService} from 'compob2b-libs';
import {Observable} from 'rxjs';
import {catchError, map, take, takeUntil, tap} from 'rxjs/operators';

@Component({
    templateUrl: './modal-location.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    styles: [`
    :host {
      ul {
        list-style: none;
        padding: 0;
        margin: 0 10px;

        li {
          width: 100%;
          font-style: normal;
          font-weight: normal;
          font-size: 16px;
          margin: 20px 0 0;
        }

        li.selected {
          color: #E30612;
        }

        li:hover {
          cursor: pointer;
        }
      }
    }`],
    standalone: false
})
export class ModalLocationComponent extends BaseComponent implements OnInit {
  customerGroups$: Observable<CustomerGroup[]>;
  selectedGroup: CustomerGroup;

  constructor(
    private readonly window: NbWindowRef,
    private readonly storeService: StoreService) {
    super();
  }

  ngOnInit(): void {
    this.customerGroups$ = this.compoApiService.get<CustomerGroup[]>('/customer-group').pipe(
      map(response => response.data), takeUntil(this.unsubscribe)
    );
    this.selectedGroup = this.storeService.getCustomerGroupLocal();
  }

  select(group: CustomerGroup): void {
    this.getCustomerGroup(group).pipe(
      take(1),
      catchError(err => this.handleError(err)),
      tap(response => this.handleResponse(response))
    ).subscribe();
  }

  private getCustomerGroup(group: CustomerGroup) {
    this.loading = true;
    const uri = '/customer-group/' + group.id;
    return this.compoApiService.get<CustomerGroup>(uri);
  }

  private handleResponse(response: ApiResponse<CustomerGroup>) {
    setTimeout(() => {
      this.storeService.setCustomerGroup(response.data);
      this.selectedGroup = response.data;
      this.loading = false;
      this.close();
    }, 300);

  }

  close() {
    this.window.close();
  }
}
